import gql from 'graphql-tag';
import { eventTimelineFragment } from './fragments';
import { simplePaginationFragment } from '../shared/paginationFragment';

export default gql`
  query eventTimelineByContextV2($filters: EventTimelineFiltersV2Input!) {
    eventTimelineByContextV2(filters: $filters) {
      collection {
        ...eventTimelineParts
      }
      pagination {
        ...simplePaginationParts
      }
    }
  }
  ${simplePaginationFragment}
  ${eventTimelineFragment}
`;
